/**
 * Calendar year-to-date helpers (local timezone dates as YYYY-MM-DD).
 */

export function formatLocalDateKey(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Inclusive YTD window from Jan 1 through `now` (local calendar). */
export function getYtdDateRange(now = new Date()) {
  const end = new Date(now);
  end.setHours(12, 0, 0, 0);
  const start = new Date(end.getFullYear(), 0, 1, 12, 0, 0, 0);
  const since = formatLocalDateKey(start);
  const until = formatLocalDateKey(end);
  return { since, until, firstdate: since, lastdate: until };
}

/**
 * Resolve performance API range params.
 * YTD uses since/until (calendar year) so it works with the existing custom-range contract.
 */
export function resolvePerformanceRangeParams(timeframe, dateRange = null) {
  if (dateRange?.since && dateRange?.until) {
    return { since: dateRange.since, until: dateRange.until };
  }
  if (timeframe === 'ytd') {
    const { since, until } = getYtdDateRange();
    return { since, until };
  }
  return { timeframe };
}
